/**
 * @since 1.0.0
 */
import * as HSP from "@effect/data/internal/Differ/HashSetPatch";
const TypeId = HSP.HashSetPatchTypeId;
/**
 * Constructs an empty set patch.
 *
 * @since 1.0.0
 * @category constructors
 */
export const empty = HSP.empty;
/**
 * Constructs a set patch from a new set of values.
 *
 * @since 1.0.0
 * @category constructors
 */
export const diff = HSP.diff;
/**
 * Combines two set patches to produce a new set patch that describes
 * applying their changes sequentially.
 *
 * @since 1.0.0
 */
export const combine = HSP.combine;
/**
 * Applies a set patch to a set of values to produce a new set of values
 * which represents the original set of values updated with the changes
 * described by this patch.
 *
 * @since 1.0.0
 * @category destructors
 */
export const patch = HSP.patch;
//# sourceMappingURL=HashSetPatch.mjs.map